<template>
  <div class="m-0 dbozone-font bg-aztecEmpire" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="game-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.name') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.paytable') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.paytable-des') }}</h5>
      </div>

      <div class="grid-container">
        <div v-for="(symbol, index) in symbols" :key="index" class="grid-item">
          <img :src="symbol.image" class="symbol-image" alt="symbol" />
          <div class="payouts">
            <div v-for="(key) in Object.keys(symbol.payouts).map(Number).sort((a, b) => b - a)" :key="key"
              class="payout-row">
              <span class="sub-text-gray-payout" :style="getDynamicMargin(symbol.id)">{{ key
                }}&nbsp;&nbsp;|</span>
              <span class="sub-text-payout">{{ symbol.payouts[key] }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.scatter-symbol') }}</h5>
      </div>

      <div class="symbol-container">
        <div>
          <div class="symbol-content">
            <img :src="require(`../../assets/ruleGames/aztecEmpire/scatter.png`)" alt="scatter-symbol"
              class="special-symbol-image" />
            <span>
              <ul class="symbol-info">
                <li class="sub-text-list-gray"> {{ $t('aztecEmpire.scatters-info') }}</li>
              </ul>
            </span>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.wild-symbol') }}</h5>
      </div>

      <div class="symbol-container">
        <div>
          <div class="symbol-content">
            <img :src="require(`../../assets/ruleGames/aztecEmpire/wild.png`)" alt="wild-symbol"
              class="special-symbol-image" />
            <span>
              <ul v-for="(li, index) in 2" :key="index" class="symbol-info">
                <li class="sub-text-list-gray">{{ $t(`aztecEmpire.wild-info${index + 1}`) }}</li>
              </ul>
            </span>
          </div>
        </div>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <div>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.symbols-info') }}
          </h5>
        </div>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.wild-on-the-way') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/aztecEmpire/wild_comming.png`)" alt="wild-coming"
          class="wild-comming-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 3" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`aztecEmpire.wild-on-the-way-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.multipliers') }}</h5>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/aztecEmpire/multiplier.png`)" alt="multiplier"
          class="multiplier-image" />
      </div>

      <div class="symbol-content pt-4">
        <span>
          <ul v-for="(li, index) in 2" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`aztecEmpire.multipliers-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.freespin') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/aztecEmpire/freespin_feature.png`)" alt="freespin-feature"
          class="freespin-feature-image" />
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span>
          <ul v-for="(li, index) in 4" :key="index" class="symbol-info">
            <li class="sub-text-list-gray">{{ $t(`aztecEmpire.freespin-des${index + 1}`) }}</li>
          </ul>
        </span>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.featurebuy') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/aztecEmpire/feature_buy_${imgLang}.png`)" alt="feature-buy"
          class="feature-buy-image" />
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span>
          <ul v-for="(li, index) in 6" :key="index" class="symbol-info">
            <li v-if="index !== 3 && index !== 4" class="sub-text-list-gray">
              {{ $t(`aztecEmpire.featurebuy-des${index + 1}`) }}
            </li>
            <li v-else-if="index === 3" class="sub-text-list-gray">
              {{ $t(`aztecEmpire.featurebuy-des${index + 1}`) }}
              {{ currencyFormatterWithSymbol(betMinMax[0]) }}
              {{ $t(`aztecEmpire.featurebuy-des${index + 1}-1`) }}
              {{ currencyFormatterWithSymbol(featureBuyMaximum) }}
            </li>
            <li v-else-if="index === 4" class="sub-text-list-gray">
              {{ $t(`aztecEmpire.featurebuy-des${index + 1}`) }}
              {{ `x${featureBuyMultiplier}` }}
              {{ $t(`aztecEmpire.featurebuy-des${index + 1}-1`) }}
            </li>
          </ul>
        </span>
      </div>

      <!-- <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/aztecEmpire/freespin_multiplier.png`)" alt="multiplier"
          class="multiplier-image" />
      </div>

      <div class="d-flex p-4 pt-5 justify-content-center align-items-center">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.freespin-des') }}</h5>
      </div> -->

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <span class="justify-content-center align-items-center">
          <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.win-line') }}</h5>
          <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.win-line-des') }}</h5>
        </span>
      </div>

      <div class="d-flex pt-4 justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/aztecEmpire/win_line.png`)" alt="win-line" class="win-line-image" />
      </div>

      <div class="d-flex p-4 pt-5 justify-content-center align-items-center">
        <span>
          <ul v-for="(li, index) in 3" :key="index" class="pt-2 sub-text-gray text-des"
            :class="`-${lang} -aztecEmpire`">
            <li v-if="index != 1">
              {{ $t(`aztecEmpire.win-line-des${index + 1}`) }}
            </li>
            <h4 v-else class="text-center m-0">
              {{ $t(`aztecEmpire.win-line-des${index + 1}`) }}
            </h4>
          </ul>
        </span>
      </div>


      <div class="payout-table">
        <img :src="require(`../../assets/ruleGames/aztecEmpire/symbols.png`)" alt="question-symbol"
          class="special-symbol-image" />
        <div class="payout-info">
          <ul>
            <li class="sub-text-gray">6 &nbsp;&nbsp;&nbsp; 80</li>
            <li class="sub-text-gray">5 &nbsp;&nbsp;&nbsp; 60</li>
            <li class="example-win">4 &nbsp;&nbsp;&nbsp; 40</li>
            <li class="sub-text-gray">3 &nbsp;&nbsp;&nbsp; 30</li>
          </ul>
        </div>

        <!-- <div class="pl-5">
          <div class="pl-5 total-win">
            <span class="example-win">40 x 6 = 240</span>
            <h5 class="sub-text-gray">{{ $t('aztecEmpire.win-line-des5') }}</h5>
          </div>
        </div> -->
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <h4 class="sub-text-gray text-des text-center m-0">
          {{ $t(`aztecEmpire.example`) }}
        </h4>
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <li v-for="(li, index) in 3" :key="index" class="sub-text-gray text-des" :class="`-${lang} -aztecEmpire`">
            {{ $t(`aztecEmpire.win-line-info${index + 1}`) }}</li>
        </span>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title adjustment-text" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.adjustment') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <div>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.adjustment-des') }}
          </h5>
          <div>
            <span class="m-0 sub-text ">{{ $t('aztecEmpire.note') }}</span>
            <span class="m-0 sub-text-gray ">{{ $t('aztecEmpire.note-des1') }}</span>
            <span class="m-0 sub-text-gray ">{{ $t('aztecEmpire.note-des2') }}</span>
          </div>
        </div>
      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.gamerule') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <h5 class="sub-text-gray text-des" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.text-rule1') }}</h5>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <img :src="require(`../../assets/ruleGames/aztecEmpire/slotmachine.png`)" alt="slotmachine"
          class="slotmachine-image" />
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <li class="sub-text-gray" :class="`-${lang} -aztecEmpire`">
            {{ $t('aztecEmpire.min-bet') }}
            {{ currencyFormatterWithSymbol(betMinMax[0]) }}</li>
          <li class="sub-text-gray" :class="`-${lang} -aztecEmpire`">
            {{ $t('aztecEmpire.max-bet') }}
            {{ currencyFormatterWithSymbol(betMinMax[1]) }}
          </li>
          <li class="sub-text-gray" :class="`-${lang} -aztecEmpire`">
            {{ $t('aztecEmpire.game-rule1-1') }}
            {{ baseBet }}
            {{ $t('aztecEmpire.game-rule1-2') }}
          </li>
          <li class="sub-text-gray" :class="`-${lang} -aztecEmpire`">
            {{ $t('aztecEmpire.game-rule2-1') }}
            {{ currencyFormatterWithSymbol(betMinMax[0]) }}
            {{ $t('aztecEmpire.to') }}
            {{ currencyFormatterWithSymbol(betMinMax[1]) }}
            {{ $t('aztecEmpire.game-rule2-2') }}</li>
          <li class="sub-text-gray" :class="`-${lang} -aztecEmpire`">
            {{ $t('aztecEmpire.game-rule3') }}
            {{ currency + `(` + formattedCurrency + `)` }}
          </li>
          <li v-for="(li, index) in 5" :key="index" class="sub-text-gray" :class="`-${lang} -aztecEmpire`">
            {{ $t(`aztecEmpire.game-rule${index + 4}`) }}
          </li>
        </span>
      </div>

      <div class="d-flex pt-2 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.round') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-left align-items-left">
        <span>
          <h5 class="sub-text-gray text-des" :class="`-${lang} -aztecEmpire`">{{ $t('aztecEmpire.round-des') }}</h5>
          <span v-for="(li, index) in 8" :key="index">
            <div
              v-if="index + 1 === 1 || index + 1 === 2 || index + 1 === 3 || index + 1 === 4 || index + 1 === 5 || index + 1 === 6">
              <span class="pb-2 [t-2 sub-text" :class="`-${lang} -aztecEmpire`">
                {{ $t(`aztecEmpire.round-title${index + 1}`) }}
                <span class="sub-text-gray" :class="`-${lang} -aztecEmpire`">{{ $t(`aztecEmpire.round-des${index + 1}`)
                }}</span>
                <li v-if="index + 1 === 5" class="sub-text-gray" :class="`-${lang} -aztecEmpire`">{{
                  $t(`aztecEmpire.round-des${index + 2}`) }}</li>
                <li v-if="index + 1 === 5" class="sub-text-gray" :class="`-${lang} -aztecEmpire`">{{
                  $t(`aztecEmpire.round-des${index + 3}`) }}</li>
              </span>
            </div>
          </span>
        </span>

      </div>

      <div class="d-flex pt-4 pb-4 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -aztecEmpire`">{{ $t('main-game.title') }}</h5>
      </div>

      <table class="control-table">
        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/spin_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.spin-button') }}</h3>
            <li v-for="(li, index) in 3" :key="index" class="sub-text-gray">
              {{ $t(`main-game.spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/autospin_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.auto_spin-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-button-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/stop_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">
              {{ $t(`main-game.auto-spin-round-des${index + 1}`) }}
            </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/betsize_btn.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.bet-option-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.bet-option-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/turbo_on.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.turbo-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.turbo-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/info_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.gamerule-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.gamerule-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/additional_btn.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.additional-menu') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.additional-menu-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/setting_btn.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.settings') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.settings-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/history_btn.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.history-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.history-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/home_btn.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.back') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.back-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/icon_wallet.png`)" alt="icon"
              class="control-icon" /></td>
          <td>
            <h3>{{ $t('main-game.wallet-balance-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{
              $t(`main-game.wallet-balance-button-des${index + 1}`) }} </li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/icon_refresh.png`)" alt="icon"
              class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.refresh-balance-button') }}</h3>
            <li class="sub-text-gray">{{ $t('main-game.refresh-balance-button-des1') }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/icon_bet.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.bet-amount-button') }}</h3>
            <li v-for="(li, index) in 3" :key="index" class="sub-text-gray">{{
              $t(`main-game.bet-amount-button-des${index + 1}`) }}</li>
          </td>
        </tr>

        <tr>
          <td><img :src="require(`../../assets/ruleGames/aztecEmpire/icon_win.png`)" alt="icon" class="control-icon" />
          </td>
          <td>
            <h3>{{ $t('main-game.winnings-button') }}</h3>
            <li v-for="(li, index) in 2" :key="index" class="sub-text-gray">{{ $t(`main-game.winnings-button-des${index
              + 1}`) }}</li>
          </td>
        </tr>
      </table>

      <div class="d-flex pt-5 justify-content-center align-items-center">
        <h5 class="text-title" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional') }}</h5>
      </div>

      <div class="d-flex p-4 justify-content-center align-items-center">
        <u>
          <li class="sub-text-gray text-des" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional-des1') }}
          </li>
          <li class="sub-text-gray text-des" :class="`-${lang} -naturalace`">{{ $t('naturalace.additional-des2') }}
          </li>
        </u>
      </div>

      <div class="p-3"></div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'rule-aztecEmpire',
  props: {
    data: Object,
    lang: String,
    imgLang: String,
    betMinMax: Array,
    currentBet: Number,
    featureBuyMaximum: Number,
    featureBuyMultiplier: Number,
    currency: String,
    isShowCurrencySymbol: Boolean,
  },
  data() {
    return {
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
      paytable: this.data.config.payTable,
      symbols: [],
    }
  },
  mounted() {
    this.generateSymbols();
  },
  computed: {
    formattedCurrency() {
      return this.$options.filters.currencySymbol(this.currency);
    }
  },
  methods: {
    currencyFormatterWithSymbol(val) {
      if (this.isShowCurrencySymbol === false) {
        this.currency = '';
      }
      return this.$options.filters.currencyFormatterWithSymbol(val, this.currency);
    },
    decimalFormat(value) {
      value = Math.round((value + Number.EPSILON) * 1000) / 1000;
      return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 3 });
    },
    generateSymbols() {
      const symbolsData = [];
      for (let i = 0; i < 11; i++) {
        const id = (11 - i) - 1;
        symbolsData.push({
          id: id,
          image: require(`../../assets/resultGame/aztecEmpire/1/symbol_${id}.png`),
          payouts: {
            3: this.decimalFormat(this.currentBet * this.data.config.payTable[id][2] / this.baseBet),
            4: this.decimalFormat(this.currentBet * this.data.config.payTable[id][3] / this.baseBet),
            5: this.decimalFormat(this.currentBet * this.data.config.payTable[id][4] / this.baseBet),
            6: this.decimalFormat(this.currentBet * this.data.config.payTable[id][5] / this.baseBet)
          }
        });
      }
      this.symbols = symbolsData;
    },
    getDynamicMargin(id) {
      const maxLength = this.decimalFormat(this.currentBet * this.data.config.payTable[id][5] / this.baseBet).length;
      let magin = 'calc(29%)'

      if (maxLength < 5) {
        magin = 'calc(29%)'
      } else if (maxLength === 5) {
        magin = 'calc(23%)'
      } else if (maxLength > 5 && maxLength < 7) {
        magin = 'calc(19%)'
      } else if (maxLength >= 7 && maxLength < 9) {
        magin = 'calc(16%)'
      } else if (maxLength >= 9 && maxLength < 11) {
        magin = 'calc(10%)'
      } else {
        magin = 'calc(5%)'
      }

      return {
        marginLeft: magin,
      };
    },
  }
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  padding: 40px;
  background-color: #202020;
  border-radius: 20px;
  margin: 20px;
}

.grid-item {
  text-align: center;
  padding-top: 10%;
}

.symbol-image {
  width: 60%;
  height: auto;
}

.payouts {
  margin-top: 10px;
}

.payout-row {
  display: flex;
  justify-content: left;
  align-items: left;
}

.symbol-container {
  margin: 5%;
  padding: 5%;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
}

.symbol-content {
  display: flex;
  align-items: center;
}

.special-symbol-image {
  width: 25%;
  margin-right: 20px;
}

.symbol-info {
  padding-left: 40px;
}

.symbol-info li {
  font-size: 3vw;
}

h2 {
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: bold;
}

.wild-comming-image {
  width: 70%;
  height: auto;
}

.multiplier-image {
  width: 95%;
  height: auto;
}

.freespin-feature-image {
  width: 60%;
  height: auto;
}

.feature-buy-image {
  width: 40%;
  height: auto;
}

.win-line-image {
  width: 70%;
  height: auto;
}

.win-line-container {
  padding: 20px;
  background-color: #2d2d2d;
  color: white;
  border-radius: 10px;
  max-width: 600px;
  margin: auto;
  font-family: 'Arial', sans-serif;
}

h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.win-line-images {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
}

.image-container {
  position: relative;
}

.check {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: green;
}

.cross {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  color: red;
}

.win-description,
.example,
.extra-info {
  margin: 10px 0;
  font-size: 14px;
}

.payout-table {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.payout-info ul {
  list-style: none;
  padding: 0;
}

.total-win {
  text-align: center;
}

.example-win {
  font-size: 3vw;
  color: #f39c12;
}

.extra-info {
  font-size: 12px;
  margin-top: 20px;
}

.slotmachine-image {
  width: 100%;
  height: auto;
}
</style>

<style>
.bg-aztecEmpire {
  background: #282828;
}

.game-title {
  font-size: 3vw;
  color: white;
}

.text-title {
  color: #fff;
  font-size: 4vw;
  text-align: center;
}

.sub-text-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
}

.sub-text-gray-payout {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin-left: calc(30%);
}

.sub-text-payout {
  color: #fff;
  font-size: 3vw;
  margin-left: 5%;
  text-align: left;
}

.sub-text-list-gray {
  color: #fff;
  opacity: 0.7;
  font-size: 3vw;
  margin: 0 auto;
}

.sub-text {
  color: #fff;
  font-size: 3vw;
  /* margin: 0 8px; */
}

.sub-bg {
  background: #202020;
  border-radius: 30px;
}

.control-table {
  width: 100%;
  border-collapse: collapse;
}

.control-table td {
  border: 3px solid #fff;
  padding: 30px;
  vertical-align: middle;
}

.control-table h3 {
  margin-bottom: 30px;
  font-size: 3vw;
  color: #fff;
}

.control-table p {
  margin: 5px 0 0 0;
  font-size: 3vw;
}

.control-icon {
  width: 150px;
  height: 150px;
}

.adjustment-text {
  padding-left: 20%;
  padding-right: 20%;
}

.text-des {
  line-height: 1.5;
}

@media (min-width: 576px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 720px;
  }
}

@media (min-width: 768px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 900px;
  }
}

@media (min-width: 1024px) {

  .container,
  .container-sm,
  .container-md {
    max-width: 1520px;
  }
}
</style>